import { FaceIcon, ImageIcon, ColorWheelIcon, SunIcon, MoonIcon, CheckIcon } from '@radix-ui/react-icons';
import React from 'react';

type IconName = 'face' | 'image' | 'colorWheel' | 'sun' | 'moon' | 'check';

type RadixIconComponent = React.ForwardRefExoticComponent<
  Omit<React.SVGProps<SVGSVGElement>, 'children'> & React.RefAttributes<SVGSVGElement>
>;

const iconMap: Record<IconName, RadixIconComponent> = {
  face: FaceIcon,
  image: ImageIcon,
  colorWheel: ColorWheelIcon,
  sun: SunIcon,
  moon: MoonIcon,
  check: CheckIcon,
};

interface IconProps extends Omit<React.SVGProps<SVGSVGElement>, 'children'> {
  name: IconName;
}

export const Icon: React.FC<IconProps> = ({ name, ...props }) => {
  const IconComponent = iconMap[name];
  if (!IconComponent) return null;
  return <IconComponent {...props} />;
};